import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AdminGuard({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center' }}>
      <div className="spinner" />
    </div>
  );
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.role !== 'admin') return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column', gap:16 }}>
      <h2 style={{ color:'var(--primary-dark)' }}>Access Denied</h2>
      <p style={{ color:'var(--text-light)' }}>You need admin privileges to access this page.</p>
      <a href="/" style={{ color:'var(--primary)', fontWeight:600 }}>← Go Home</a>
    </div>
  );
  return children;
}
